<template>
               

                <div class="row layout-spacing ">

                    <div class=" col-lg-6 col-md-6 col-sm-6 col-xl-6">
                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-income-widget">
                                <div class="media">
                                    <div class="icon ml-2">
                                        <i class="flaticon-user-11"></i>
                                    </div>
                                    <div class="media-body text-right">
                                        <p class="widget-text mb-0">إجمالى عدد ابنائي </p>
                                        <p class="widget-numeric-value">{{data.students}} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-6 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6">
                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-order-widget">
                                <div class="media">
                                    <div class="icon ml-2">
                                        <i class="flaticon-cart-bag"></i>
                                    </div>
                                    <div class="media-body text-right">
                                        <p class="widget-text mb-0">إجمالى عدد حلقات ابنائي</p>
                                        <p class="widget-numeric-value">{{data.lessons}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="clearfix"></div>
                    <div class="col-md-12 mt-5">
                        <h5>التردد اليومى</h5>
                    </div>
                    <div class="col-xl-4 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6 mt-5">
                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-sales-widget">
                                <div class="media">
                                    إجمالى التردد اليومى للحلقات
                                </div>
                                <div class="media">
                                    حضور: {{ data.totalStats.presence }}
                                    غياب: {{ data.totalStats.absence }}
                                    تأخير: {{ data.totalStats.delay }}
                                    الاستأذان: {{ data.totalStats.excuse }}
                                </div>
                            </div>
                            <apexchart type="donut" width="100%"  :options="chartOptions" :series="[makePerc(data.totalStats.presence, data.totalStats.total), makePerc(data.totalStats.absence, data.totalStats.total), makePerc(data.totalStats.excuse, data.totalStats.total), makePerc(data.totalStats.delay, data.totalStats.total)]"></apexchart>
                            <!-- <div v-else class="spinner-border text-center" role="status">
                            <span class="sr-only">Loading...</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-xl-4 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6 mt-5" v-for="(d, i) in data.lessonsStats" :key="i">
                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-sales-widget">
                                <div class="media">
                                    {{d.lesson_name}} - (المعلم: {{ d.teacher ? d.teacher.name : '---' }})
                                </div>
                                <div class="media">
                                    حضور: {{ d.presence }}
                                    غياب: {{ d.absence }}
                                    تأخير: {{ d.delay }}
                                    الاستأذان: {{ d.excuse }}
                                </div>
                            </div>
                            <apexchart v-if="!d.loading" type="donut" width="100%"  :options="chartOptions" :series="[makePerc(d.presence, d.total), makePerc(d.absence, d.total), makePerc(d.excuse, d.total), makePerc(d.delay, d.total)]"></apexchart>
                            <div v-else class="spinner-border text-center" role="status">
                            <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>

                   
<!-- 
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6" v-if="user.role == 'parent'">

                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-income-widget">
                                <div class="media">
                                    <div class="icon ml-2">
                                        <i class="flaticon-user-11"></i>
                                    </div>
                                    <div class="media-body text-right">
                                        <p class="widget-text mb-0">عدد الطلبات المقدمة </p>
                                        <p class="widget-numeric-value">{{data.childs}} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6" v-if="user.role == 'parent'">

                        <div class="widget-content-area  data-widgets br-4">
                            <div class="widget  t-income-widget">
                                <div class="media">
                                    <div class="icon ml-2">
                                        <i class="flaticon-user-11"></i>
                                    </div>
                                    <div class="media-body text-right">
                                        <p class="widget-text mb-0">ابنائي المقبولين </p>
                                        <p class="widget-numeric-value">{{data.accpt}} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                </div>
                

</template>

<script>
import Vue from "vue";
import baseApi from '@/baseApi'

export default {
  components: {
  },
  data() {
    return {
        chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      data: {
        totalStats: {
            presence: 0,
            absence: 0,
            delay: 0,
            excuse: 0,
            total: 0
        },
        lessonsStats: [],
        stages: 0,
        students: 0,
        parents: 0,
        teachers: 0,
        groups: 0,
        lessons: 0,
        childs: 0,
        accpt: 0,
        errors: {},
        isRequested: false,
        form: {
          capacity: ''
        }
      },
      statsCards: [
      ],
      activityChart: {
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          axisX: {
            showGrid: false
          },
          height: "500px"
        }
      },
    }
  },
  created() {
   this.getStates();
  },
  methods: {
    getTransKey(k) {
      return this.trans.dashboard ? this.trans.dashboard.databy[k] : k;
    },
    sendStatsRequest(mod) {
      baseApi().get('/counter?q=' + mod).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.statsCards.push(response.data.data);
        } else if (response.data.code === 404) {
        } else {
          alert(response.data.error);
        }
      });
    },
    modDetails() {
      return ['users', 'managemnt', 'passports'];
    },
    handleModules(mod, data) {
    },
    getStates() {
      baseApi().get('/home').then((response) => {
        if (response.data.code === 200) {
            this.data.students    = response.data.data.studentCount;
            this.data.lessons     = response.data.data.lessonCount;
            this.data.lessonsStats          = response.data.data.dataStats;
            let vm = this;
            Object.keys(this.data.lessonsStats).forEach(function(key) {
                vm.getLessonDetails(key);
            });
          
        }
      });
    },
    getLessonDetails(lessonId){
        baseApi().get('/get-lesson-stats?id='+lessonId).then((response) => {
        if (response.data.code === 200) {
            let res = response.data.data;
            this.data.lessonsStats[lessonId] = res;
            this.data.totalStats.absence = this.data.totalStats.absence + res.absence;
            this.data.totalStats.presence = this.data.totalStats.presence + res.presence;
            this.data.totalStats.delay = this.data.totalStats.delay + res.delay;
            this.data.totalStats.excuse = this.data.totalStats.excuse + res.excuse;
            this.data.totalStats.total = this.data.totalStats.excuse + res.total;
        }
      });
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return Math.round((n/t) * 100);
    }
  },
  computed: {
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
.ct-bar {
  stroke-width: 17px !important;
}
.card .ct-chart {
  height: auto !important;
}
.card .footer div {
  width: 100%;
  text-align: center;
}
</style>
